import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import React, { useMemo } from 'react';
import { composeRenderProps } from 'react-aria-components';
import _FieldError from './aria/field-error.esm.js';

var _excluded = ["className"];
function FieldError(_ref) {
  var _className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className) {
      return "csg-tw-field-error ".concat(cn('text-e-0.75 text-status-negative', className));
    });
  }, [_className]);
  return /*#__PURE__*/React.createElement(_FieldError, _extends({}, props, {
    className: classes
  }));
}

export { FieldError as default };
//# sourceMappingURL=field-error.esm.js.map
